import AUValidationSchema from "modules/new-applications/components/application-actions/PPSRRegister/validationSchema/AUValidationSchema";
import NZValidationSchema from "modules/new-applications/components/application-actions/PPSRRegister/validationSchema/NZValidationSchema";

export { AUValidationSchema };
export { NZValidationSchema };
